//-----------------------------------------------------------------------------
// Michael B. Gale's Website
// Copyright (c) 2022 Michael B. Gale (hello@michael-gale.co.uk)
//-----------------------------------------------------------------------------

import * as React from "react";
import "@fontsource/pt-serif";
import "@fontsource/fira-code";
import { Helmet } from 'react-helmet';
import Footer from "./Footer";

//-----------------------------------------------------------------------------

const Layout = (props: React.PropsWithChildren<{}>) => {
    return <>
        <Helmet
            defaultTitle="Michael B. Gale"
        />
        <main>
            {props.children}
        </main>
        <Footer />
    </>
}

export default Layout;

//-----------------------------------------------------------------------------
